import Keycloak from 'keycloak-js';

export function createKeycloak(realm) {
    return new Keycloak({
        url:        'https://keycloak.bioailab.com.br',
        realm,                               // ← vem do tenant
        clientId:   'bioialab-crm',
    });
}
